const RAIL_GROUP = {
    FLAGGED: 'flagged',
    CLEAR: 'clear',
    NOT_RUN: 'notRun',
    UNKNOWN: 'unknown'
}

const RAIL_GROUP_LABEL = {
    [RAIL_GROUP.FLAGGED]: 'Flagged',
    [RAIL_GROUP.CLEAR]: 'Clear',
    [RAIL_GROUP.NOT_RUN]: 'Not run',
    [RAIL_GROUP.UNKNOWN]: 'Reports'
}

const IGNORED_STATUSES = ['NOT_IMPLEMENTED']

const ALERT = {
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO'
}

const ALERT_RANK = [ALERT.ERROR, ALERT.WARNING, ALERT.INFO]

const alertOf = (entry) => String(entry?.status?.alert || '').toUpperCase()

const groupForEntry = (entry) => {
    const value = entry?.status?.value
    if (!value || value === 'NOT_IMPLEMENTED') return RAIL_GROUP.UNKNOWN

    if (alertOf(entry) === ALERT.ERROR) return RAIL_GROUP.FLAGGED
    if (value === 'REQUIRES_RESOLUTION' || value === 'WAITING_RESPONSE') return RAIL_GROUP.FLAGGED
    if (value === 'NOT_DONE') return RAIL_GROUP.NOT_RUN

    return RAIL_GROUP.CLEAR
}

const SEVERITY = [RAIL_GROUP.FLAGGED, RAIL_GROUP.CLEAR, RAIL_GROUP.NOT_RUN, RAIL_GROUP.UNKNOWN]

const mostSevere = (groups) => SEVERITY.find(group => groups.includes(group)) || RAIL_GROUP.UNKNOWN

const worstAlert = (entries) => {
    const alerts = entries.map(alertOf)
    return ALERT_RANK.find(level => alerts.includes(level)) || null
}

const buildRailModel = (reports = [], summaryEntries = []) => {
    const usable = summaryEntries.filter(entry => !IGNORED_STATUSES.includes(entry?.status?.value))

    return reports.map(report => {
        const entries = report.summaryKey
            ? usable.filter(entry => entry.type === report.summaryKey)
            : []

        if (!entries.length) {
            return {
                ...report,
                railGroup: RAIL_GROUP.UNKNOWN,
                alertLevel: null,
                flaggedCount: 0,
                entryCount: 0
            }
        }

        const groups = entries.map(groupForEntry)
        return {
            ...report,
            railGroup: mostSevere(groups),
            alertLevel: worstAlert(entries),
            flaggedCount: groups.filter(group => group === RAIL_GROUP.FLAGGED).length,
            entryCount: entries.length
        }
    })
}

const getRunCount = (model = []) => {
    const known = model.filter(report => report.railGroup !== RAIL_GROUP.UNKNOWN)
    return {
        run: known.filter(report => report.railGroup !== RAIL_GROUP.NOT_RUN).length,
        total: known.length
    }
}

export {
    RAIL_GROUP,
    RAIL_GROUP_LABEL,
    ALERT,
    groupForEntry,
    buildRailModel,
    getRunCount
}
